// --> Declaring all gloval variables here 
export const JSON_FORMAT = "Json"
export const PAYLOAD_None = "";

// --> This var is used to mention which type of message when sending thru websoc
export const RequestTypes = {
  REQUEST: 1,
  RESPONSE: 2,
  BROADCAST: 3,
};

export const APIs = {
    ICICI: "ICICI",
    FlatTrade: "FlatTrade",
    PaperTrade: "PaperTrade",
};

export const WebSocMessage = {
  CATEGORY: {
    NAME: "CATEGORY",
    Progress: "Progress",
    Alert: "Alert",
    Chart: "Chart",
    Trade: "Trade",
    Tickers: "Tickers", 
  },
  CHART_SERIES_TYPE: {
    NAME: "SERIES",
    Candlestick: "Candlestick",
    Histogram: "Histogram",
    Line: "Line",
    Area: "Area",
    Bar: "Bar",
    Baseline: "Baseline",
  },
  CHART_MSG_TYPE: {
    NAME: "MSGTYPE",
    ADD: "ADD",
    UPDATE: 'UPDATE',
    COMPLETE: 'COMPLETE',
  },
  TICKERS_MSG_TYPE:{
    NAME        : "MSGTYPE",
    TECH        : 'Tech',
  },
  TypeofBroadCast:{
    OHLC    : "OHLC",
    Trade   : "Trade",
    Error   : "Error",
    Tech    : "Tech",
  } 
};

export class WebSocSubscribeBroadcastPayLoad {
  constructor() {
    this.Channel = '';
    this.Error = true;
    this.OHLC = false;
    this.Trade = false;
    this.UserDetails = {};
  }
  toJSON() {
    return {
      Channel: this.channel,
      OHLC: this.OHLC,
      Trade: this.Trade,
      UserDetails: this.UserDetails,
    };
  }
}
// --> This var holds the hierarchie of the Client names, module names, function names that are used to send direct messages thru WebSocs
export const TargetClientName = {
  SERVER: {
    NAME: "Server",
    MODULE_SERVER: {
      NAME: "Server",
      FUNCTION_SERVER: {
        Join: "Join",
        JoinWithACK: "JoinWithACK",
        Ack: "Ack",
        SubscribeBroadcast: "SubscribeBroadcast",
        UnSubscribeBroadcast: "UnSubscribeBroadcast",
      },
    },
  },
  CORE: {
    NAME: "Core",
    MODULE_API: {
      NAME: "API",
      FUNCTION_API: {
        getAPIlist: "getAPIlist",
        UpdateSessionKey: "UpdateSessionKey",
        ConnToAPI: "ConnToAPI",
        getCustomerDetails: "getCustomerDetails",
        SearchCompanyDetails: "SearchCompanyDetails",
        getStockCompanyALL: "getStockCompanyALL",
        AddSelectedStockCompanyDetails: "AddSelectedStockCompanyDetails",
        UpdateSelectedStockCompanyDetails: "UpdateSelectedStockCompanyDetails",
        DeleteSelectedStockCompanyDetails: "DeleteSelectedStockCompanyDetails",
        getHistoricData: "getHistoricData",
      },
    },
    MODULE_BACKTESTING: {
      NAME: "BACKTESTING",
      FUNCTION_BACKTESTING: {
        RunBackTesting: "RunBackTesting",
        PullBackTestingResult: "PullBackTestingResult",
        RequestGraphData: "RequestGraphData",
      },
    },
    MODULE_STRATEGY: {
      NAME: "STRATEGY",
      FUNCTION_STRATEGY: {
        AddNewStrat: "AddNewStrat",
        getStratList: "getStratList",
        getStratDetails: "getStratDetails",
        updateStratDetails: "updateStratDetails",
      },
    },
    MODULE_LIVETRADE: {
      NAME: "LIVETRADE",
      FUNCTION_LIVETRADE: {
        SubscribeBroadcast: "SubscribeBroadcast",
        UnSubscribeBroadcast: "UnSubscribeBroadcast",
        Broadcast: "Broadcast",
        AddStockCode: "AddStockCode",
        updateStockCode:"updateStockCode",
        getStockCodeList: "getStockCodeList",
        getPreviousCDLs: "getPreviousCDLs",
        processOrder: "processOrder",
      },
      FUNCTION_TRADECONFIG: {
        getStockTradeSettings: "getStockTradeSettings",
        updateStockTradeSettings: "updateStockTradeSettings",
      },
    },
    MODULE_CEREBRO: {
      NAME: "CEREBRO",
      FUNCTION_CEREBRO: {
        UpdateDashboard: "UpdateDashboard",
      },
    },
  },
  AUTOMATION: {
    NAME: "AUTOMATION", 
    MODULE_AUTOMATION: {
      NAME: "AUTOMATION",
      FUNCTION_AUTOMATION: {
        Login : "Login",
      },
    },
  },
};

export const OrderProcessType = {
  NewOrder    : "NewOrder",
  ModifyOrder : "ModifyOrder",
  CancelOrder : "CancelOrder",
  ExitOrder   : "ExitOrder",
  OrderUpdates: "OrderUpdates",
}

// --> Country & Currency Configuration (Centralized)
export const SUPPORTED_COUNTRIES = [
    { code: 'ALL', label: 'ALL MARKET' },
    { code: 'IN', label: 'INDIA', flags: ['NSE', 'BSE', 'NFO', 'BFO', 'MCX', 'CDS'], currency: 'INR' },
    { code: 'US', label: 'USA', flags: ['NASDAQ', 'NYSE', 'CME'], currency: 'USD' },
    { code: 'JP', label: 'JAPAN', flags: ['JPX', 'TYO'], currency: 'JPY' }
];

export const COUNTRY_FLAGS = {
    'IN': '🇮🇳',
    'US': '🇺🇸',
    'JP': '🇯🇵',
    'GB': '🇬🇧',
    'UK': '🇬🇧',
    'DE': '🇩🇪',
    'CN': '🇨🇳',
    'HK': '🇭🇰',
    'SG': '🇸🇬',
    'AU': '🇦🇺'
};

export const CURRENCY_CONFIG = {
    'IN': { code: 'INR', symbol: '₹', locale: 'en-IN' },
    'US': { code: 'USD', symbol: '$', locale: 'en-US' },
    'JP': { code: 'JPY', symbol: '¥', locale: 'ja-JP' },
    'GB': { code: 'GBP', symbol: '£', locale: 'en-GB' },
    'UK': { code: 'GBP', symbol: '£', locale: 'en-GB' },
    'EU': { code: 'EUR', symbol: '€', locale: 'de-DE' }
};
